import * as React from "react"
import { App } from "./app"
import { BDKalkCore } from "./BDKalkCore"

///////////////   ProjectSaveView  ////////////////

/* ProjectSaveView is displayed when the user has requested to save the current project. */

export interface ProjectSaveViewVm  {
    app: App
}

export interface ProjectSaveViewStateVm {
    stage: string
}

// Project save view is displayed at the right hand side if the user attempts to save a project
export class ProjectSaveView extends React.Component<ProjectSaveViewVm, ProjectSaveViewStateVm> {
    state = {
        stage: "initial"
    }

    constructor(props: ProjectSaveViewVm) {
        super(props)
        this.m_name = ""
        this.m_tooUnspicificName = false
    }

    componentWillMount() {
        this.props.app.GetCore().ConnectProjectSaveView(this)
    }

    OnSave() {
        if (this.m_projectName != null) {
            this.m_name = this.m_projectName.value
        }
        
        var occurances = this.props.app.GetCore().ConvertArticleAmountOccuranceCollect(false)
        if (occurances.length > 0) {
            this.setState({ stage: "convertQuestion" })
            return
        }

        if (this.props.app.GetCore().GetSelectionSetManager().HasPreviouslySavedProjectName(this.m_name) == true) {
            this.setState({ stage: "overwriteQuestion" })
        }
        else {
            // Checking if the name is generated like a new project name or is given a more specific title
            var name = this.m_name

            if (name) {
                if (name.length > 10) {
                    if (name.slice(0, 11) == "Nytt utvalg") {
                        this.m_tooUnspicificName = true
                        this.forceUpdate()
                        return
                    }
                }
            }

            this.OnSaveSure()
        }
    }

    OnSavePreSureOld() {
        this.m_name = this.m_projectName.value
        this.OnSaveSure()
    }

    OnSaveSure() {
        this.props.app.GetCore().GetSelectionSetManager().SaveProject(this.m_name, null)
        this.setState({ stage: "confirmingSave" })
    }

    OnConvert() {
        this.props.app.GetCore().ConvertArticleAmounts()
        this.OnSave()
    }
    
    OnCansel() {
        this.props.app.setState({ DisplayMode: this.props.app.DMode.QReport })
    }

    // 
    OnOK() {
        this.props.app.setState({ DisplayMode: this.props.app.DMode.QReport })
    }

    // Giving focus to the text input item where to type in the name for this project save - delayedly
    SetFocus() {
        if (this.m_projectName != null) {
            this.m_projectName.value = this.props.app.GetCore().GetSelectionSetManager().GetCurrentProjectName()
            setTimeout(this.SetFocusFulfill.bind(this), 80)
        }
    }
    
    // Giving focus to the text input item where to type in the name for this project save
    SetFocusFulfill() {
        var element = document.getElementById("projectNameInput");
        element && element.focus()
    }

    render() {
        var specificAlert = <div>
            <div style={{ color: "red" }}>* Vennligst angi et mer spesifikt</div>
            <div style={{ color: "red", position:"relative", left:"10px" }}>navn til utvalget.</div>
        </div>

        if (this.m_tooUnspicificName == false) {
            specificAlert = <div></div>
        }

        // Initial stage: Lagre utvalg som... [input]
        if (this.state.stage == "initial") {
            setTimeout(this.SetFocus.bind(this), 150)

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{width:"calc(50% - 50px)", height:"1px"}}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Lagre utvalg som..</div>
                    <input
                        id="projectNameInput"
                        type="text"
                        ref={(input) => { if (input != null) this.m_projectName = input }}
                        style={{ width: "150px", height: "35px", position: "relative", top: "9px" }}>
                    </input>
                    <div onClick={this.OnSave.bind(this)} style={{ backgroundColor: "grey", width: "64px", height: "30px", position: "relative", top: "20px", cursor: "pointer"}}>
                        <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor:"pointer" }}>
                            Lagre
                        </div>
                    </div>

                    <div style={{ position: "relative", top: "46px", left:"-10px", width: "100%" }}>
                        {specificAlert}
                    </div>
                </div>
            </div>
        }

        // Checks if the user wants to overwrite a saved project with the identical name
        if (this.state.stage == "overwriteQuestion") {
            setTimeout(this.SetFocus.bind(this), 150)

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Er du sikker på at du vil</div>
                    <div>overskrive det tidligere</div>
                    <div>utvalget med samme</div>
                    <div>navn?</div>

                    <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                        <div onClick={this.OnSaveSure.bind(this)} style={{ backgroundColor: "grey", width: "64px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Lagre
                            </div>
                        </div>

                        <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left:"20px",cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Avbryt
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        }

        // Checks if the user wants to convert custom selections of supplier/package into default settings
        if (this.state.stage == "convertQuestion") {
            setTimeout(this.SetFocus.bind(this), 150)

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Utvalget innholder noen valg av</div>
                    <div>leverandør eller type av pakke</div>
                    <div>som ikke er standard, vis du vil</div>
                    <div>lagre utvalget må disse valgen</div>
                    <div>først omregnes fra de valgte</div>
                    <div>alternativen til de opprinnerlige.</div>
                    <div>dette skjer vis du klikker "Omregne",</div>
                    <div>ellers klikk "Avbryt".</div>

                    <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                        <div onClick={this.OnConvert.bind(this)} style={{ backgroundColor: "grey", width: "94px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Omregne
                            </div>
                        </div>

                        <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Avbryt
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        }

        // Checks if the user wants to overwrite a saved project with the identical name
        if (this.state.stage == "confirmingSave") {
            setTimeout(this.SetFocus.bind(this), 150)

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Ditt utvalg er nå lagret.</div>

                    <div onClick={this.OnOK.bind(this)} style={{ backgroundColor: "grey", width: "44px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                        <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                            OK
                        </div>
                    </div>
                </div>
            </div>
        }

        return <div>(save project view)</div>
    }

    private m_name: string // keeps the name while the view gets unmounted due to changes in the stage
    private m_projectName: HTMLInputElement
    private m_tooUnspicificName : boolean
}



// WEBPACK FOOTER //
// ./client/view/ProjectSaveView.tsx